import React from "react";
import JamezzFormV2 from "../JamezzForm/JamezzFormV2";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import Algemeen from "./Tabs/Algemeen";
import Translations from "./Tabs/Translations";
import AuthProvider from "../../auth/AuthProvider";
import { connect } from "react-redux";
import useVestigingRelation from "../../components/Forms/useVestigingRelation";
import { formatTitle } from "../../../utils/formatting";
import { Link } from "react-router";

const endPoint = "core/tags";

function TagForm(props) {
  const { currency, menukaartVestigingId, vestiging, extraFields, onGetModel } = useVestigingRelation({
    vestiging_id: props.vestiging_id,
    routerMatch: props.match,
    history: props.history,
    endPoint,
  });

  return (
    <AuthProvider prefix={"tags"}>
      <JamezzFormV2
        computedPageTitle={function (model) {
          return formatTitle(this.pageTitle, model.tagName);
        }}
        endPoint={endPoint}
        extraFields={extraFields}
        extraFormProps={{ vestiging, vestigingId: vestiging?.id, menukaartVestigingId }}
        objectsExcludedAsRelation={{ translations: true }}
        onGetModel={(model) => {
          onGetModel(model);
        }}
        pageTitle={getTranslation("tags.form.pageTitle", "Tags")}
        pageTitleSubject={function (model) {
          return (
            <small>
              <Link to={`/manager/vestigingen/${model.vestiging_id}/edit`}>{model.salesAreaName}</Link> -{" "}
              {model.vestiging_id}
            </small>
          );
        }}
        parseInput={{
          translations: (response) => (response ? JSON.parse(response) : null),
          img_uuids: (response) => {
            return response
              ? JSON.parse(response).map((uuid) => ({
                  uuid: uuid,
                }))
              : [];
          },
        }}
        parseOutput={{
          translations: (translations) => (translations ? JSON.stringify(translations) : null),
          img_uuids: (img_uuid) => img_uuid,
        }}
        tabs={[
          {
            right: "algemeen",
            tabButton: <TranslationWrapper tDefault={"Algemeen"} tKey={"tags.form.tabs.algemeen"} />,
            tabContent: <Algemeen />,
          },
          {
            right: "translations",
            tabButton: <TranslationWrapper tDefault={"Translations"} tKey={"translations"} />,
            tabContent: <Translations />,
          },
        ]}
      />
    </AuthProvider>
  );
}

const mapStateToProps = (state) => {
  return {
    vestiging_id: state.filtersV2.vestiging_id?.value,
  };
};

export default connect(mapStateToProps)(TagForm);
